// extracted by mini-css-extract-plugin
export default {"popoverContent":"popover_popoverContent__MrJRh","popoverArrow":"popover_popoverArrow__-0wZy","removeButtonStyling":"popover_removeButtonStyling__Hcetc"};